<template>
  <ThemeProvider>
    <article class="text-white layout-landing-us">
      <slot />
    </article>
  </ThemeProvider>

  <sound-btn
    v-if="showVoiceControl"
    class="layout-landing-us__sound-btn muted-btn"
    :muted="muted"
    @click="toggleMuted"
  />

  <Account />
  <MobileBottomUserPop ref="mobileUserRef" />
</template>
<script lang="ts" setup>
import { PageKey } from '@/constants/page';
import ThemeProvider from '@/design/widgets/theme-provider/index.vue';
import Account from '@/features/account/index.vue';
import SoundBtn from '@/features/landing/sound-btn/index.vue';
import { useRoute } from 'vue-router';
import MobileBottomUserPop from '~/design/widgets/mobile-bottom-user-pop-en/index.vue';
import { getCookie, setCookie } from '~/utils/cookie';

const route = useRoute();
const mobileUserRef = ref<{ open: () => void } | null>(null);
const { createMobileUserPopOwner, registerMobileUserPop } = useMobileUserPop();
const mobileUserPopOwnerId = createMobileUserPopOwner();

const showVoiceControl = computed(() => {
  return route.name !== PageKey.TEMPLATE_INFO && route.name !== PageKey.CHARACTER_DETAIL;
});

const key = 'x-muted';
// x-muted 1 unmuted 0 muted
const muted = ref(+getCookie(key) === 1 ? false : true);

provide('isMuted', muted);

const toggleMuted = () => {
  muted.value = !muted.value;
  setCookie(key, muted.value ? 0 : 1);
};

watch(
  mobileUserRef,
  value => {
    registerMobileUserPop(mobileUserPopOwnerId, value ? () => value.open() : null);
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  registerMobileUserPop(mobileUserPopOwnerId, null);
});
</script>

<style lang="scss" src="./styles/layout.mobile.scss" />
<style lang="scss" src="./styles/layout.pc.scss" />

<!--
<style lang="scss">
.layout-landing-us {
  width: 100%;
  min-width: 1280px;
  font-family: 'Poppins', sans-serif;
}
.noto {
  font-family: 'Noto Serif Display', serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-variation-settings: 'wdth' 62.5;
}
</style> -->
